import { GridCellParams } from '@mui/x-data-grid-pro';

export const FIELD_KEY_SEPARATOR = '_';

export type FieldKeyComponents = {
  id: string;
  type: string;
  idIndex: number;
  typeIndex: number;
};

export type FieldKeyConfig = {
  key: string; // Configurable pinned column key
};

export function createFieldKey(components: FieldKeyComponents, config: FieldKeyConfig): string {
  const { id, type, idIndex, typeIndex } = components;

  return id
    ? `${id}${FIELD_KEY_SEPARATOR}${type}${FIELD_KEY_SEPARATOR}${idIndex}${FIELD_KEY_SEPARATOR}${typeIndex}`
    : config.key;
}

export function parseFieldKey(
  key: GridCellParams['field'],
  config: FieldKeyConfig,
): FieldKeyComponents | null {
  if (key === config.key) {
    return null;
  }

  const [id, type, idIndexStr, typeIndexStr] = key.split(FIELD_KEY_SEPARATOR);

  const idIndex = parseInt(idIndexStr, 10);
  const typeIndex = parseInt(typeIndexStr, 10);

  return {
    id,
    type,
    idIndex,
    typeIndex,
  };
}

export function isPinnedColumn(field: string, config: FieldKeyConfig): boolean {
  return field === config.key;
}

export function isDynamicColumn(field: string, config: FieldKeyConfig): boolean {
  return !isPinnedColumn(field, config) && field.includes(FIELD_KEY_SEPARATOR);
}

export function isValidFieldKey(field: string, config: FieldKeyConfig): boolean {
  if (isPinnedColumn(field, config)) return true;

  const parsed = parseFieldKey(field, config);
  return parsed !== null;
}

export function createFieldKeyConfig(key: string): FieldKeyConfig {
  return {
    key,
  };
}

export function createFieldKeyFromArray(components: string[]): string {
  return components.join(FIELD_KEY_SEPARATOR);
}
